export const isDefined = <T>(argument: null | T | undefined): argument is T => {
  return argument !== undefined && argument !== null;
};
